module.exports = __webpack_public_path__ + "static/media/covid.064aa294.JPG";